import type { PropsWithChildren } from 'react';
import { ConnectionLayout } from 'components/login/ConnectionLayout';
import posthog from 'posthog-js';
import React, { useCallback } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { PrimaryButtonV2 } from '@fragment/ui/src/components/Button/PrimaryButtonV2/PrimaryButtonV2';
import { SecondaryButtonV2 } from '@fragment/ui/src/components/Button/SecondaryButtonV2/SecondaryButtonV2';
import { Icon } from '@fragment/ui/src/components/Icon';

export const ErrorFallback = (): JSX.Element => (
  <ConnectionLayout title="Page load error">
    <div className="flex flex-col items-start gap-f1">
      <PrimaryButtonV2
        className="inline-flex items-center gap-f1 px-[1ch] py-fhalf"
        onClick={() => window.location.reload()}
      >
        Reload{' '}
        <span aria-hidden="true">
          <Icon type="rotate" size="md" />
        </span>
      </PrimaryButtonV2>
      <SecondaryButtonV2
        className="inline-flex items-center gap-f1 px-[1ch] py-fhalf"
        onClick={() =>
          window.location.assign(
            document.referrer && document.referrer !== window.location.href
              ? document.referrer
              : '/'
          )
        }
      >
        Back to Dashboard{' '}
        <span aria-hidden="true">
          <Icon type="right" size="md" />
        </span>
      </SecondaryButtonV2>
    </div>
  </ConnectionLayout>
);

export const GlobalErrorBoundary = ({
  children,
}: PropsWithChildren): JSX.Element => {
  const onError = useCallback((error: Error) => {
    posthog.captureException(error);
  }, []);

  return (
    <ErrorBoundary onError={onError} FallbackComponent={ErrorFallback}>
      {children}
    </ErrorBoundary>
  );
};
